import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/question',
    name: 'Question',
    meta: {
      title: '提问',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/questionAnswer/question/index.vue'),
  },
  {
    path: '/myQuestion',
    name: 'MyQuestion',
    meta: {
      title: '我的提问',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/questionAnswer/myQuestion/index.vue'),
  },
  {
    path: '/qaList',
    name: 'QaList',
    meta: {
      title: '问答列表',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/questionAnswer/qaList/index.vue'),
  },
  {
    path: '/selectCar', // 选择车型
    name: 'SelectCar',
    meta: {
      title: '选择车型',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/questionAnswer/selectCar/index.vue'),
  },
  {
    path: '/questionDetail',
    name: 'QuestionDetail',
    meta: {
      title: '问答详情',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/questionAnswer/questionDetail/index.vue'),
  },
]
export default routes
